export default () => ({
  vehicles: [],
  vehicle: null,
  defaultVehicle: {
    firm: null,
    contact: null,
    vehicle: -1,
    year: '2007',
    make: 0,
    model: '',
    vin: ''
  },
  adasIds: null,
  adas: null
})



// WEBPACK FOOTER //
// ./src/store/modules/vehicles/state.js